(() => {
  if(window.GuildsArtworkTransfer)return;
  let connection;
  const database=()=>connection ||= new Promise((resolve,reject)=>{
    const request=indexedDB.open('guilds-artwork-handoff',1);
    request.onupgradeneeded=()=>request.result.createObjectStore('artwork',{keyPath:'token'});
    request.onsuccess=()=>resolve(request.result);
    request.onerror=()=>{connection=null;reject(request.error);};
  });
  const transact=async(mode,action)=>{
    const db=await database();
    return new Promise((resolve,reject)=>{
      const transaction=db.transaction('artwork',mode),request=action(transaction.objectStore('artwork'));
      transaction.oncomplete=()=>resolve(request?.result);
      transaction.onerror=()=>reject(transaction.error);
      transaction.onabort=()=>reject(transaction.error);
    });
  };
  window.GuildsArtworkTransfer={
    async save(record){
      const records=await transact('readonly',store=>store.getAll());
      for(const old of records)if(old.expires<Date.now())await transact('readwrite',store=>store.delete(old.token));
      const token=crypto.randomUUID();
      await transact('readwrite',store=>store.put({...record,token,expires:Date.now()+30*60*1000}));
      return token;
    },
    async get(token){
      const record=await transact('readonly',store=>store.get(token));
      if(record && record.expires>Date.now())return record;
      if(record)await this.remove(token);
      return null;
    },
    remove(token){return transact('readwrite',store=>store.delete(token));}
  };
})();
